/**
 * PromotionHomeContainer
 * --
 */
import React from 'react';
import PromotionHomePresenter from './PromotionHomePresenter';
import { STORE_URL } from 'utils';
import dayjs from 'dayjs';
import { useGetPromotions } from 'hooks/PromotionHooks';
import { useGetMapGroupProducts } from 'hooks/GroupProductHooks';

const PromotionHomeContainer = (props) => {
  /* ===== Props ===== */
  const { navigate, screenSize, type = 'promotion' } = props;

  const query = {
    is_show: 'Y',
  };
  const options = {
    select: (res) => {
      const { status, data } = res;

      if (status !== 200) return [];

      return data;
    },
    initialData: [],
  };

  /* ===== Data ===== */
  // NOTE: 프로모션
  const { data: Promotions } = useGetPromotions(
    { ...query, examination_status: 'APPROVE' },
    {
      ...options,
      enabled: type === 'promotion' ? true : false,
    }
  );
  // NOTE: 그룹상품
  const { data: Groups } = useGetMapGroupProducts(query, {
    ...options,
    enabled: type === 'recipe' ? true : false,
  });

  /* ===== VARIABLE ===== */
  const today = React.useMemo(() => dayjs().unix(), []);

  /* ===== HOOKS ===== */
  /**
   * 목록 데이터 정제
   * --
   */
  const Data = React.useMemo(() => {
    let newData = [];

    switch (type) {
      case 'promotion':
        if (!Promotions.length) {
          newData = [];
        } else {
          newData = Promotions.filter((item) => item.is_show === "Y").map((_item) => {
            const { promotion_start_date, promotion_end_date } = _item;

            const status =
              promotion_start_date > today
                ? 'PREV'
                : promotion_end_date < today
                  ? 'END'
                  : 'ING';

            return {
              ..._item,
              src: _item.thumbnail_url
                ? `${STORE_URL}/${_item.thumbnail_url}`
                : null,
              description: _item?.promotion_description,
              status: status,
            };
          }).sort((a, b) => b.promotion_end_date - a.promotion_end_date);
        }
        break;
      case 'recipe':
        if (!Groups.length) {
          newData = [];
        } else {
          newData = Groups.map((_item) => ({
            ..._item,
            src: _item.thumbnail_url
              ? `${STORE_URL}/${_item.thumbnail_url}`
              : null,
            description: _item?.promotion_description,
          })).sort((a, b) => a.order - b.order);
        }
        break;
      default:
        break;
    }

    return newData;
  }, [type, today, Promotions, Groups]);

  /* ===== RENDER ===== */
  return (
    <>
      <PromotionHomePresenter
        navigate={navigate}
        screenSize={screenSize}
        data={Data}
        type={type.toLocaleUpperCase()}
      />
    </>
  );
};

export default PromotionHomeContainer;
